import React from 'react';

import {
  SimProductsEditDialog,
  SimProductsEditDialogContentProps,
} from 'products/sim/Edit/SimProductEditDialog';
import { useRefreshDetailEntry } from './hooks/useRefreshDetailEntry';
import { useSimProductDetails } from './hooks/useSimProductDetails';

type SimProductsEditDialogProps = Omit<
  SimProductsEditDialogContentProps,
  'onTagsChange' | 'onCustomFieldsChange' | 'data'
> & { iccid: string };

export const SimProductDetailsEditDialog = React.memo(
  ({ iccid, ...props }: SimProductsEditDialogProps) => {
    const { data } = useSimProductDetails(iccid);

    const { refreshTags, refreshCustomFields } = useRefreshDetailEntry(iccid);

    return (
      <SimProductsEditDialog
        {...props}
        data={data}
        onTagsChange={refreshTags}
        onCustomFieldsChange={refreshCustomFields}
      />
    );
  },
);
